//components
import { BasicBreadcrumbs, BasicButton, SimpleTable } from "thrive-components";

//hooks
import UseSourceListSelector from "./SourceListSelector.hooks";



const SourceListSelector = () => {
    const {breadcrumbs, showBackButton, onBackButtonClick, tableData, handleModalClose} = UseSourceListSelector();
    
    return (
        <div>
            <h1 className='feed-modal-title'>Add Source List(s)</h1>

            <BasicBreadcrumbs 
                breadCrumbs={breadcrumbs}
            />
             
            <SimpleTable
                {...tableData}
            />

            <div className="source-list-modal-panel ">
                {showBackButton &&
                    <BasicButton 
                        content={"Back"}
                        className='cancel-button-style back-button'
                        onButtonClick={onBackButtonClick} 
                        ariaLabel={'Back to parent list'}                
                    />
                }
                
                <BasicButton 
                    content={"Close"}
                    className='close-modal-button'
                    onButtonClick={handleModalClose} 
                    ariaLabel={'Close modal'}                
                />
            </div>
        </div>
    );  
}

export default SourceListSelector;